import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { formatUserName } from '@witmetrics/utils/strings';
import type { DecoratedTaskTemplate } from '@witmetrics/utils';
import { PersonIcon, TimeIcon } from '@/icons';
import { formatDueIn } from '../utils';
import { classes, styles } from './utils';

export type ResultsListProps = {
  results?: DecoratedTaskTemplate[];
  onSelect: (template: DecoratedTaskTemplate) => void;
};

export default function ResultsList({
  results = [],
  onSelect,
}: ResultsListProps) {
  return (
    <List className={classes.list}>
      {results.map((template) => (
        <ListItem key={template.id} disablePadding>
          <ListItemButton
            sx={styles.listItemButton}
            className={classes.listItemButton}
            onClick={() => onSelect(template)}>
            <div className={classes.content}>
              <div className={classes.primary}>{template.description}</div>
              <div className={classes.secondary}>
                <span className={classes.secondaryGroup}>
                  <PersonIcon className={classes.secondaryIcon} />
                  {template.assignedTo
                    ? formatUserName(template.assignedTo)
                    : '--'}
                </span>
                <span className={classes.secondaryGroup}>
                  <TimeIcon className={classes.secondaryIcon} />
                  {template.dueIn ? formatDueIn(template.dueIn) : '--'}
                </span>
              </div>
            </div>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
